import React from 'react';
interface PasoProps {
  num: string;
  titulo: string;
  children: React.ReactNode;
}
export function Paso({
  num,
  titulo,
  children
}: PasoProps) {
  return <section className="mb-3.5 rounded-card border border-line bg-surface p-[17px] shadow-card md:p-5" data-id="element-56" data-mp="3fynq5di2adba">
      <div className="mb-4 flex items-baseline gap-2.5" data-id="element-57" data-mp="3ktupk94asvue">
        <span className="shrink-0 font-mono text-[11px] font-bold tracking-[0.06em] text-accent" data-id="element-58" data-mp="3orsfje5w7lyu">{num}</span>
        <h2 className="display display-tight text-[17.5px]" data-id="element-59" data-mp="2s4dzhi45hr1c">{titulo}</h2>
      </div>
      {children}
    </section>;
}